import React, { useState } from 'react'

import { Avatar, Icon } from '../../../../components/UI'
import MultiTalent from '../../../../components/Shared/MultiTalent'
import UpcomingClassLanguage from '../../Statistic/UpcomingClassLanguage'

import { arrayFromNumber, getUserName } from '../../../../helpers'

import { imagePrefix } from '../../../../constants'

const AcceptClassDetailsTutor = ({ classBanner }) => {
  const [liked, setLiked] = useState(true)

  const handleLike = () => {
    setLiked((prevState) => !prevState)
  }

  // TODO
  const handleSendMessage = () => {}

  const starsContent = arrayFromNumber(4).map((star) => {
    return <Icon key={star} name="sun-check" className="w-[32px] h-[32px]" />
  })

  const languagesContent = (classBanner?.creator_profile?.languages || []).map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  return (
    <div className="w-[50%] flex flex-col items-center justify-center p-[10px] bg-[#FFF5EE] border-[#FFCA84] border-[1px] rounded-[6px]">
      <div className="relative flex w-full items-center justify-center">
        <Avatar
          src={
            classBanner.class_banner_creator.profile_picture
              ? `${imagePrefix}${classBanner.class_banner_creator.profile_picture}`
              : ''
          }
          gender={classBanner.class_banner_creator.gender}
          className="w-[48px] h-[48px]"
        />

        <button className="absolute right-0 flex" onClick={handleLike}>
          <Icon
            name="heart"
            className={`w-[36px] h-[36px] ${liked ? 'text-[#EF4343]' : 'text-transparent stroke-[#EF4343]'} transition-colors duration-200 ease`}
          />
        </button>
      </div>

      <h3 className="text-sm font-bold text-primary-100 text-center w-full mt-[12px]">
        {getUserName(
          classBanner.class_banner_creator,
          classBanner.creator_profile?.display_name,
          classBanner.creator_profile?.display_last_name
        )}
      </h3>

      <MultiTalent className="mt-[12px]" />

      <div className="mt-[12px] gap-x-[2px] flex items-center justify-center flex-wrap w-full">
        {starsContent}
      </div>

      <div className="w-full flex items-center justify-center flex-wrap gap-[16px] mt-[12px]">
        <div className="flex justify-center items-center">
          <img
            className="w-[24px] h-[24px]"
            src={'/assets/icon/checkbox-multiple-line.svg'}
            alt="Checkbox"
          />

          <span className="font-normal ml-1 text-sm text-[#F67443]">
            {classBanner.tutor_stats?.total_bookings || 0}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <img className="w-[24px] h-[24px]" src={'/assets/icon/user-green.svg'} alt="User" />

          <span className="font-normal ml-1 text-sm text-[#F67443]">
            {classBanner.tutor_stats?.total_students || 0}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <img className="w-[24px] h-[24px]" src={'/assets/icon/star.svg'} alt="Star" />
          <span className="font-normal ml-1 text-sm text-[#F67443]">
            {classBanner.tutor_stats?.overall_rating_average || 0}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <span className="text-[#B733DD] text-sm font-semibold">ROI</span>
          <span className="text-[#F67443] font-normal ml-1 text-sm">
            {classBanner.tutor_stats?.roi || 0}%
          </span>
        </div>
      </div>

      <div className="flex items-center justify-center flex-wrap w-full mt-[12px]">
        <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px] w-[22px] h-[22px]" />

        <ul className="flex items-center flex-wrap max-w-[70%] gap-x-[4px]">{languagesContent}</ul>
      </div>

      {/* TODO */}
      <div className="flex items-center justify-center w-full mt-[12px]">
        <div className="flex items-center mr-[10px]">
          <img src={'/assets/icon/globleIcon.png'} />
          <img src={`/assets/icon/britain.png`} className="w-[24px] h-[24px] ml-[4px]" />
        </div>

        <div className="flex items-center">
          <img src={`/assets/icon/homeOrangeIcon.png`} />
          <img src={`/assets/icon/britain.png`} className="w-[24px] h-[24px] ml-[4px]" />
        </div>
      </div>

      <button
        type="button"
        className="mt-[12px] h-[32px] w-[200px] bg-white rounded-[8px] border-primary-button border-[1px] shadow-button flex items-center justify-center text-sm font-semibold text-primary-button transition-colors duration-200 ease hover:!bg-primary-button-hover hover:text-white hover:!border-primary-button-hover"
        onClick={handleSendMessage}
      >
        Send Message
      </button>
    </div>
  )
}

export default AcceptClassDetailsTutor
